import './Usluge.css';

function Usluge() {
  return (
    <div className="usluge-container">
      <h1>Naše usluge</h1>
      <p className="intro-text">
        KEHSEF d.o.o. nudi sveobuhvatne usluge u području kibernetičke sigurnosti 
        i usklađenosti s EU regulativama.
      </p>

      <div className="service-section">
        <h2>Provjera EU zahtjeva za kibernetičku sigurnost</h2>
        <p>
          Provjera EU zahtjeva za kibernetičku sigurnost odnosi se na proces osiguravanja 
          usklađenosti s regulativama i standardima Europske unije vezanim uz kibernetičku sigurnost. 
          To je posebno važno za organizacije koje djeluju unutar EU ili obrađuju podatke građana EU.
        </p>
        <p>
          Ovi zahtjevi često proizlaze iz EU direktiva i regulativa.
        </p>
      </div>

      <div className="service-section">
        <h2>Usluge GAP analize za usklađenost s DORA-om</h2>
        <p>
          EU Regulativa 2022/2554, poznata kao Zakon o digitalnoj operativnoj otpornosti (DORA), 
          ima za cilj jačanje digitalne operativne otpornosti financijskih subjekata unutar 
          Europske unije. Postavlja pravila i okvire za osiguranje da financijske institucije 
          mogu izdržati, odgovoriti i oporaviti se od ICT (Informacijsko-komunikacijske tehnologije) 
          poremećaja ili kibernetičkih incidenata.
        </p>
        <p>
          GAP analiza je ključni dio procesa usklađenosti. Koristi se za procjenu trenutnog stanja 
          politika, procesa i sustava organizacije u odnosu na zahtjeve postavljene u DORA-i. 
          Cilj je identificirati sve nedostatke ili praznine koje bi mogle spriječiti usklađenost 
          s regulativom te potom razviti strategije za njihovo zatvaranje.
        </p>
      </div>

      <div className="service-section">
        <h2>Usluge usklađenosti s NIS 2</h2>
        <p>
          NIS 2 (Direktiva o mrežnim i informacijskim sustavima 2) je zakonodavni akt Europske unije 
          koji ima za cilj unaprijediti kibernetičku sigurnost u kritičnim sektorima, uključujući energiju, 
          transport, zdravstvo i digitalnu infrastrukturu. Nadograđuje originalnu NIS direktivu (NIS 1) 
          i pojačava zahtjeve za upravljanje rizicima kibernetičke sigurnosti, izvještavanje o incidentima 
          i otpornost mrežnih i informacijskih sustava.
        </p>
      </div>

      <div className="service-section">
        <h2>Usluge CISO-as-a-Service</h2>
        <p>
          Outsourcing funkcije Chief Information Security Officer (CISO) sve je popularniji za tvrtke koje 
          traže visokokvalitetno vođenje sigurnosti bez troškova i resursa potrebnih za stalnog zaposlenika. 
          Ovaj pristup omogućuje pristup iskusnim stručnjacima za sigurnost, učinkovito strateško planiranje 
          i poboljšane prakse kibernetičke sigurnosti bez izazova zapošljavanja i zadržavanja vrhunskih talenata.
        </p>
      </div>

      <div className="service-section">
        <h2>Neovisna procjena obaveznih SWIFT CSP zahtjeva</h2>
        <p>
          U KEHSEF d.o.o imamo kvalificirane stručnjake sposobne provesti neovisnu procjenu 
          obaveznog Customer Security Programa (CSP) SWIFT-a. Neovisnu procjenu mogu provesti 
          kvalificirani treći auditorji sa stručnim znanjem u kibernetičkoj sigurnosti i poznavanjem 
          SWIFT CSP okvira. Preporučuju se godišnje procjene kako bi se osigurala stalna usklađenost 
          i praćenje ažuriranja u SWIFT sigurnosnim zahtjevima.
        </p>
        <p>
          Neovisna procjena obaveznih SWIFT CSP zahtjeva je ključna procjena koja osigurava da financijske 
          institucije održavaju visoke standarde kibernetičke sigurnosti. SWIFT CSP uveden je kako bi 
          se adresirali kibernetički rizici povezani s korištenjem SWIFT-ovih usluga razmjene poruka, 
          postavljajući obaveznu osnovu sigurnosti u cijeloj globalnoj mreži.
        </p>
      </div>

      <div className="service-section">
        <h2>Trening za kibernetičku osviještenost</h2>
        <p>
          Trening za kibernetičku osviještenost je ključan u današnjem digitalnom svijetu, gdje su 
          kibernetičke prijetnje poput phishinga, ransomwarea i socijalnog inženjeringa sve sofisticiranije. 
          Cilj ovog treninga je educirati pojedince i organizacije o najboljim praksama za zaštitu osjetljivih 
          informacija, prepoznavanje prijetnji i učinkovito reagiranje na potencijalne sigurnosne proboje.
        </p>
      </div>
    </div>
  );
}

export default Usluge;
